import Head from "next/head";

import HowItWorksMain from "@/components/how-it-works/how-it-works-main";
import SeoMetaData from "@/components/utils/seo-metadata";
import seoData from "@/data/seo/page-data.json";

export default function HowItWorks() {
  return (
    <>
      <Head>
        <title>{seoData.HOW_IT_WORKS.title}</title>
        <SeoMetaData data={seoData.HOW_IT_WORKS} />
      </Head>

      <HowItWorksMain />
    </>
  );
}
